<app-banner></app-banner>
<iframe aria-label='HINDU SENIOR SECONDARY SCHOOL' frameborder="0" style="height:1000px;width:100%;border:none;"
    src='https://data.odpay.in/odforms1/form/HINDUSENIORSECONDARYSCHOOL/formperma/JJ2PmPHsBVVd3tdyKKjEnxM1Q-fbGM-BmPwYQXldORM'></iframe>